import React from "react";
import { Page, Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import gradientOverlay from "../../assets/coverOverlay.png";
import defaultCover from "../../assets/defalutCover.jpg";
import logoDefault from "../../assets/efficient-logo.png";

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    opacity: 1,
    objectFit: "cover",
  },
  container: {
    flex: 1,
    padding: 0,
    justifyContent: "flex-start",
  },
  logoBox: {
    backgroundColor: "#fff",
    padding: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 40,
    borderBottomRightRadius: 40,
    alignSelf: "center",
    marginBottom: 20,
    width: "25%",
    textAlign: "center",
  },
  logo: {
    width: 150,
    height: 50,
    objectFit: "contain",
    margin: "auto",
  },
  heading: {
    fontSize: 50,
    fontWeight: "bold",
    color: "#fff",
    textAlign: "center",
    letterSpacing: 1,
    fontFamily: "Montserrat",
  },
  subHeading: {
    fontSize: 35,
    color: "#fff",
    marginTop: 0,
    textAlign: "center",
    fontFamily: "Montserrat",
    fontWeight: "medium",
  },
  middleSection: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    paddingVertical: 2,
    marginVertical: 14,
  },
  middleSectionNone: {
    alignItems: "center",
    justifyContent: "center",
  },
  highlightRow: {
    flexDirection: "row",
    alignItems: "baseline",
  },
  highlightBlue: {
    fontSize: 50,
    fontWeight: "bold",
    color: "#031B76",
    marginRight: 8,
    textTransform: "uppercase",
    fontFamily: "Montserrat",
  },
  highlightRed: {
    fontSize: 50,
    fontWeight: "bold",
    color: "#BF0000",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
  },
  date: {
    fontSize: 50,
    color: "#fff",
    marginTop: 12,
    fontWeight: "medium",
    fontFamily: "Montserrat",
  },
  tagline: {
    fontSize: 24,
    color: "#fff",
    textAlign: "center",
    fontFamily: "Montserrat",
    maxWidth: "75%",
    alignItems: "center",
    justifyContent: "center",
    margin: "20px auto 0",
  },
});

const CoverSlide = ({
  bg,
  logo,
  heading,
  subHeading,
  highlight,
  highlight2,
  date,
  tagline,
}) => {
  const backgroundImage = bg || defaultCover;
  const logoDefaultImage = logo || logoDefault;
  return (
    <Page
      size={{ width: PDF_PAGE.width, height: PDF_PAGE.height }}
      style={styles.page}
    >
      <Image src={backgroundImage} style={styles.background} />

      <Image src={gradientOverlay} style={styles.overlay} />

      <View style={styles.container}>
        <View>
          {logo && (
            <View style={styles.logoBox}>
              <Image src={logoDefaultImage} style={styles.logo} />
            </View>
          )}
          <Text style={styles.heading}>{heading}</Text>
          <Text style={styles.subHeading}>{subHeading}</Text>
        </View>

        <View style={styles.middleSection}>
          <View style={styles.highlightRow}>
            <Text style={styles.highlightBlue}>{highlight}</Text>
            <Text style={styles.highlightRed}>{highlight2}</Text>
          </View>
        </View>
        <View style={styles.middleSectionNone}>
          <Text style={styles.date}>{date}</Text>
        </View>

        <Text style={styles.tagline}>{tagline}</Text>
      </View>
    </Page>
  );
};

export default CoverSlide;
